import { Badge, type BadgeProps } from "./Badge";
import { Pip, type PipProps } from "./Pip";

/**
 * Constrained vocabulary (badge | pip) for ListItem/SelectionTile primary-row
 * trailing. RowLayout itself accepts any ReactNode. Badges auto-size to small.
 */
export type DecorativeTrailing = ({
  type: "badge";
} & Omit<BadgeProps, "size">) | ({
  type: "pip";
} & PipProps);
export const DecorativeTrailing = (props: DecorativeTrailing) => {
  switch (props.type) {
    case "badge":
      {
        const {
          type: _type,
          ...badgeProps
        } = props;
        return <Badge size="small" {...badgeProps} />;
      }
    case "pip":
      {
        const {
          type: _type,
          ...pipProps
        } = props;
        return <Pip {...pipProps} />;
      }
  }
};